import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { belongsTo, attr } from '@ember-data/model';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
let ExpireDateModel = (_dec = belongsTo('expense', {
  inverse: 'expire_dates',
  async: false
}), _dec2 = attr('string'), _dec3 = attr('number', {
  currency: true
}), _dec4 = attr('string'), _dec5 = attr('string'), _dec6 = attr('string'), _dec7 = attr('boolean', {
  defaultValue: false
}), _class = class ExpireDateModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "expense", _descriptor, this);
    _initializerDefineProperty(this, "expire_date", _descriptor2, this);
    _initializerDefineProperty(this, "total", _descriptor3, this);
    _initializerDefineProperty(this, "payment_method", _descriptor4, this);
    _initializerDefineProperty(this, "assurance_id", _descriptor5, this);
    _initializerDefineProperty(this, "notes", _descriptor6, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor7, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "expense", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "expire_date", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "total", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "payment_method", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "assurance_id", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "notes", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { ExpireDateModel as default };
//# sourceMappingURL=expire-date.js.map
